import React, { Component } from 'react';
import { connect } from "react-redux";
import { setArrangementXScale } from "actions/index.js";
import {getBarWidth} from './getBarWidth.js';

class TimeBackgroundComponent extends Component {
    get numberOfBars() {
        return 100;
    }

    render() {
        let bars = new Array(this.numberOfBars); 
        bars.fill(0);
        let barWidth = getBarWidth(1, this.props.resolution, this.props.xScale);

        return (
            <div
             className="time-background">
              {bars.map(
                  (bar, i) =>
                      <BarComponent
                        barWidth={barWidth}
                        selectionStart={this.props.selectionStart}
                        selectionEnd={this.props.selectionEnd}
                        resolution={this.props.resolution} number={i}/>)}
            </div>
        );
    }
}

class BarComponent extends Component {
    render() {
        let beat = this.props.number*(16 / this.props.resolution);
        let style = {
            width: this.props.barWidth,
        };
        return (
            <div
              style={style}
              className="bar">
              <div className="beat">
              </div>
              <div className="beat"></div>
              <div className="beat"></div>
              <div className="last-beat"></div>
            </div>
        );
    }

}

const mapDispatchToProps = (dispatch, props) => {
    let subSequenceId = props.subSequence.id;
    return {
        setArrangementXScale: (xScale) => dispatch(
            setArrangementXScale(xScale)),
    };
};
 
const mapStateToProps = (state, props) => {
    return {
        xScale: state.arrangement.xScale,
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(TimeBackgroundComponent);
